import { useNavigate } from "react-router-dom";
import SwitchToggle from "../../components/SwitchToggle";

const ManageProductsDetail = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>Product Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - <button onClick={() => navigate("/manage-products")}>Manage Products</button> - Product Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="gap_p">
          <div className="vew_img v2 no_radius w_100">
            <h6>Product Image</h6>
            <figure>
              <img alt="user" src="/static/images/placeholder.png" />
            </figure>
          </div>
          <div className="w_33">
            <h6>Product Name</h6>
            <p>Espresso</p>
          </div>
          <div className="w_33">
            <h6>Category</h6>
            <p>Beverages</p>
          </div>
          <div className="w_33">
            <h6>Type</h6>
            <p>Double Variant</p>
          </div>
          <div className="w_33">
            <h6>Price</h6>
            <p>
              <strong>Single:</strong> 3.500 K.D
              <br />
              <strong>Double:</strong> 4.500 K.D
            </p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>01-Sept-2025</p>
          </div>
          <div className="w_33">
            <h6>Status</h6>
            <SwitchToggle />
          </div>
          <div className="w_100">
            <h6>Description</h6>
            <p>Dive into the world of our Espresso coffee, a true masterpiece crafted from the finest Arabica beans harvested from the most exquisite coffee-growing regions around the globe. Each bean is handpicked with care and roasted to perfection, ensuring that every cup delivers an explosion of rich, bold flavors that dance on your palate. The luxurious, velvety crema that adorns each serving not only enhances the visual appeal but also adds a sumptuous texture, transforming your coffee ritual into an extraordinary experience. Whether you're starting your day with a burst of energy or treating yourself to a delightful afternoon escape, our Espresso is designed to awaken your senses and provide a moment of pure indulgence with every sip.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageProductsDetail;
